import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import { colors } from 'components/styles/_variables';
import { respondTo } from 'components/styles/_respondTo';

export const StyledToastContainer = styled(ToastContainer).attrs({
  // custom props
})`
  ${respondTo.mobile`
      top: 67px;
      width: calc(100vw - 15px);
      margin: auto;
      right: 0;
      left: 0;
    `}
  .Toastify__toast-container {
    //z-index: 999999999999;
  }
  .Toastify__toast {}
  .Toastify__toast--error {
    //color: white;
    //background-color: ${colors.theme.danger};
  }
  .Toastify__toast--warning {}
  .Toastify__toast--success {
    //background-color: ${colors.theme.primary};
  }
  .Toastify__toast-body {}
  .Toastify__progress-bar {}
`;
